
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

const MENU_CONFIG = {
  admin: [
    { name: 'Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Workflow', path: '/sales/workflow', icon: 'ri-flow-chart' },
    { name: 'Catalog', path: '/products', icon: 'ri-shopping-bag-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Inventory', path: '/inventory', icon: 'ri-store-line' },
    { name: 'Warranty', path: '/warranty/claims', icon: 'ri-shield-check-line' },
    { name: 'QC Management', path: '/qc', icon: 'ri-check-double-line' },
    { name: 'Customers', path: '/customer/list', icon: 'ri-user-line' },
    { name: 'Vendors', path: '/vendor/list', icon: 'ri-building-line' },
    { name: 'Billing', path: '/billing/invoices', icon: 'ri-bill-line' },
  ],
  ceo: [
    { name: 'CEO Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Executive Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Strategic Decisions', path: '/ceo/decisions', icon: 'ri-lightbulb-line' },
    { name: 'Company Analytics', path: '/reports/branch', icon: 'ri-line-chart-line' },
    { name: 'Final Approvals', path: '/ceo/approvals', icon: 'ri-shield-check-line' },
    { name: 'Discount Proposals', path: '/operations/discount-proposals', icon: 'ri-coupon-line' },
  ],
  director: [
    { name: 'Executive Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Strategic Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Policy Management', path: '/director/policies', icon: 'ri-file-shield-line' },
    { name: 'High Value Approvals', path: '/director/approvals', icon: 'ri-vip-crown-line' },
    { name: 'Branch Analytics', path: '/reports/branch', icon: 'ri-bar-chart-line' },
    { name: 'Operations Overview', path: '/operations/vendor-changes', icon: 'ri-eye-line' },
  ],
  operations_head: [
    { name: 'Operations Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Discount Management', path: '/operations/discount-categories', icon: 'ri-coupon-line' },
    { name: 'Vendor Changes', path: '/operations/vendor-changes', icon: 'ri-exchange-line' },
    { name: 'Discount Proposals', path: '/operations/discount-proposals', icon: 'ri-file-list-line' },
    { name: 'Approval Workflow', path: '/operations/approvals', icon: 'ri-check-double-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
  ],
  ho_manager: [
    { name: 'HO Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Margin Fixation', path: '/ho-manager/margins', icon: 'ri-percent-line' },
    { name: 'Order Processing', path: '/ho-manager/orders', icon: 'ri-file-list-3-line' },
    { name: 'Rate Management', path: '/ho-manager/rates', icon: 'ri-price-tag-3-line' },
    { name: 'Vendor Management', path: '/ho-manager/vendors', icon: 'ri-building-line' },
    { name: 'Product Approval', path: '/ho-manager/products', icon: 'ri-checkbox-circle-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Notifications', path: '/notifications', icon: 'ri-notification-line' },
  ],
  sales_head: [
    { name: 'Sales Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Overview', path: '/sales/overview', icon: 'ri-bar-chart-line' },
    { name: 'Team Performance', path: '/sales/team', icon: 'ri-team-line' },
    { name: 'Target Management', path: '/sales/targets', icon: 'ri-trophy-line' },
    { name: 'Customer Analytics', path: '/reports/customers', icon: 'ri-user-search-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
  ],
  regional_manager: [
    { name: 'Regional Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Branch Management', path: '/regional/branches', icon: 'ri-building-2-line' },
    { name: 'Regional Sales', path: '/sales/regional', icon: 'ri-line-chart-line' },
    { name: 'Inventory Overview', path: '/inventory/regional', icon: 'ri-store-line' },
    { name: 'Staff Management', path: '/regional/staff', icon: 'ri-group-line' },
    { name: 'Reports', path: '/reports/branch', icon: 'ri-file-chart-line' },
  ],
  manager_pobs: [
    { name: 'POBS Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Point Management', path: '/pobs/points', icon: 'ri-map-pin-line' },
    { name: 'Sales Tracking', path: '/pobs/sales', icon: 'ri-line-chart-line' },
    { name: 'Inventory Status', path: '/inventory', icon: 'ri-store-line' },
    { name: 'Customer Service', path: '/customer/service', icon: 'ri-customer-service-line' },
    { name: 'Reports', path: '/reports/pobs', icon: 'ri-file-chart-line' },
  ],
  branch_manager: [
    { name: 'Branch Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Workflow', path: '/sales/workflow', icon: 'ri-flow-chart' },
    { name: 'Branch Operations', path: '/branch/operations', icon: 'ri-settings-line' },
    { name: 'Staff Management', path: '/branch/staff', icon: 'ri-team-line' },
    { name: 'Inventory', path: '/inventory', icon: 'ri-store-line' },
    { name: 'Customer Management', path: '/customer/list', icon: 'ri-user-line' },
    { name: 'Reports', path: '/reports/branch', icon: 'ri-file-chart-line' },
  ],
  store_manager: [
    { name: 'Store Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Management', path: '/sales/workflow', icon: 'ri-shopping-cart-line' },
    { name: 'Store Operations', path: '/store/operations', icon: 'ri-store-line' },
    { name: 'Inventory', path: '/inventory', icon: 'ri-box-line' },
    { name: 'Customer Service', path: '/customer/list', icon: 'ri-customer-service-line' },
    { name: 'Daily Reports', path: '/reports/daily', icon: 'ri-calendar-line' },
  ],
  manager: [
    { name: 'Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Workflow', path: '/sales/workflow', icon: 'ri-flow-chart' },
    { name: 'Catalog', path: '/products', icon: 'ri-shopping-bag-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Inventory', path: '/inventory', icon: 'ri-store-line' },
    { name: 'Warranty', path: '/warranty/claims', icon: 'ri-shield-check-line' },
    { name: 'QC Management', path: '/qc', icon: 'ri-check-double-line' },
    { name: 'Customers', path: '/customer/list', icon: 'ri-user-line' },
    { name: 'Billing', path: '/billing/invoices', icon: 'ri-bill-line' },
  ],
  sales: [
    { name: 'My Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Sales Workflow', path: '/sales/workflow', icon: 'ri-flow-chart' },
    { name: 'Catalog', path: '/products', icon: 'ri-shopping-bag-line' },
    { name: 'Orders', path: '/billing/invoices', icon: 'ri-shopping-cart-line' },
    { name: 'Old Gold', path: '/inventory/old-gold', icon: 'ri-coins-line' },
    { name: 'Customers', path: '/customer/list', icon: 'ri-user-line' },
    { name: 'Warranty', path: '/warranty/claims', icon: 'ri-shield-check-line' },
  ],
  qc: [
    { name: 'QC Dashboard', path: '/qc', icon: 'ri-check-double-line' },
    { name: 'Inspections', path: '/qc/orders', icon: 'ri-search-eye-line' },
    { name: 'Checklists', path: '/qc/checklists', icon: 'ri-task-line' },
    { name: 'Warranty', path: '/warranty/repairs', icon: 'ri-tools-line' },
  ],
  finance: [
    { name: 'Dashboard', path: '/', icon: 'ri-dashboard-line' },
    { name: 'Billing', path: '/billing/invoices', icon: 'ri-bill-line' },
    { name: 'Reports', path: '/reports/finance', icon: 'ri-file-chart-line' },
    { name: 'Rate Fixation', path: '/billing/rates', icon: 'ri-price-tag-3-line' },
  ],
  customer: [
    { name: 'Home', path: '/customer', icon: 'ri-home-line' },
    { name: 'My Orders', path: '/customer/orders', icon: 'ri-shopping-bag-line' },
    { name: 'Warranty', path: '/customer/warranty', icon: 'ri-shield-check-line' },
    { name: 'Profile', path: '/customer/profile', icon: 'ri-user-settings-line' },
  ],
};

const ROLE_DISPLAY_NAMES = {
  admin: 'System Admin',
  ceo: 'CEO',
  director: 'Director',
  operations_head: 'Operations Head',
  ho_manager: 'HO Manager',
  sales_head: 'Sales Head',
  regional_manager: 'Regional Manager',
  manager_pobs: 'Manager POBS',
  branch_manager: 'Branch Manager',
  store_manager: 'Store Manager',
  manager: 'General Manager',
  sales: 'Sales Executive',
  qc: 'Quality Control',
  finance: 'Finance',
  customer: 'Customer',
};

export function Sidebar() {
  const location = useLocation();
  const { user } = useAuthStore();

  if (!user) return null;

  // Get dynamic menu items based on user role
  const getMenuItems = () => {
    switch (user?.role) {
      case 'ceo':
        return [
          { icon: 'ri-dashboard-line', label: 'CEO Dashboard', path: '/ceo/dashboard' },
          { icon: 'ri-file-chart-line', label: 'Executive Reports', path: '/reports/finance' },
          { icon: 'ri-settings-line', label: 'Strategic Decisions', path: '/operations/discount-proposals' },
          { icon: 'ri-bar-chart-line', label: 'Company Analytics', path: '/reports/branch' },
          { icon: 'ri-check-double-line', label: 'Final Approvals', path: '/operations/discount-proposals' },
          { icon: 'ri-team-line', label: 'Leadership Team', path: '/admin/system' },
        ];
      case 'director':
        return [
          { icon: 'ri-dashboard-line', label: 'Executive Dashboard', path: '/director/dashboard' },
          { icon: 'ri-file-chart-line', label: 'Strategic Reports', path: '/reports/finance' },
          { icon: 'ri-settings-line', label: 'Policy Management', path: '/operations/discount-categories' },
          { icon: 'ri-check-line', label: 'High Value Approvals', path: '/operations/discount-proposals' },
          { icon: 'ri-bar-chart-line', label: 'Branch Analytics', path: '/reports/branch' },
          { icon: 'ri-eye-line', label: 'Operations Overview', path: '/operations/vendor-changes' },
        ];
      case 'operations_head':
        return [
          { icon: 'ri-dashboard-line', label: 'Operations Dashboard', path: '/' },
          { icon: 'ri-percent-line', label: 'Discount Management', path: '/operations/discount-categories' },
          { icon: 'ri-user-settings-line', label: 'Vendor Changes', path: '/operations/vendor-changes' },
          { icon: 'ri-file-list-line', label: 'Discount Proposals', path: '/operations/discount-proposals' },
          { icon: 'ri-flow-chart', label: 'Approval Workflow', path: '/operations/discount-proposals' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
        ];
      case 'ho_manager':
        return [
          { icon: 'ri-dashboard-line', label: 'HO Dashboard', path: '/ho-manager/dashboard' },
          { icon: 'ri-percent-line', label: 'Margin Fixation', path: '/ho-manager/products' },
          { icon: 'ri-shopping-bag-line', label: 'Order Processing', path: '/ho-manager/orders' },
          { icon: 'ri-money-rupee-circle-line', label: 'Rate Management', path: '/ho-manager/rates' },
          { icon: 'ri-user-line', label: 'Vendor Management', path: '/ho-manager/vendors' },
          { icon: 'ri-check-line', label: 'Product Approval', path: '/products' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
          { icon: 'ri-notification-line', label: 'Notifications', path: '/notifications' },
        ];
      case 'sales_head':
        return [
          { icon: 'ri-dashboard-line', label: 'Sales Dashboard', path: '/' },
          { icon: 'ri-line-chart-line', label: 'Sales Overview', path: '/sales/workflow' },
          { icon: 'ri-team-line', label: 'Team Performance', path: '/reports/se' },
          { icon: 'ri-target-line', label: 'Target Management', path: '/sales/orders' },
          { icon: 'ri-user-heart-line', label: 'Customer Analytics', path: '/customers' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
        ];
      case 'regional_manager':
        return [
          { icon: 'ri-dashboard-line', label: 'Regional Dashboard', path: '/' },
          { icon: 'ri-building-line', label: 'Branch Management', path: '/reports/branch' },
          { icon: 'ri-line-chart-line', label: 'Regional Sales', path: '/sales/workflow' },
          { icon: 'ri-box-line', label: 'Inventory Overview', path: '/inventory' },
          { icon: 'ri-team-line', label: 'Staff Management', path: '/admin/system' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
        ];
      case 'manager_pobs':
        return [
          { icon: 'ri-dashboard-line', label: 'POBS Dashboard', path: '/' },
          { icon: 'ri-map-pin-line', label: 'Point Management', path: '/sales/workflow' },
          { icon: 'ri-line-chart-line', label: 'Sales Tracking', path: '/sales/orders' },
          { icon: 'ri-box-line', label: 'Inventory Status', path: '/inventory' },
          { icon: 'ri-customer-service-line', label: 'Customer Service', path: '/customers' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
        ];
      case 'branch_manager':
        return [
          { icon: 'ri-dashboard-line', label: 'Branch Dashboard', path: '/' },
          { icon: 'ri-shopping-cart-line', label: 'Sales Workflow', path: '/sales/workflow' },
          { icon: 'ri-settings-line', label: 'Branch Operations', path: '/orders/fulfillment' },
          { icon: 'ri-team-line', label: 'Staff Management', path: '/admin/system' },
          { icon: 'ri-box-line', label: 'Inventory', path: '/inventory' },
          { icon: 'ri-user-line', label: 'Customer Management', path: '/customers' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/branch' },
        ];
      case 'store_manager':
        return [
          { icon: 'ri-dashboard-line', label: 'Store Dashboard', path: '/' },
          { icon: 'ri-shopping-cart-line', label: 'Sales Management', path: '/sales/workflow' },
          { icon: 'ri-settings-line', label: 'Store Operations', path: '/orders/fulfillment' },
          { icon: 'ri-box-line', label: 'Inventory', path: '/inventory' },
          { icon: 'ri-customer-service-line', label: 'Customer Service', path: '/customers' },
          { icon: 'ri-file-chart-line', label: 'Daily Reports', path: '/reports/branch' },
        ];
      case 'general_manager':
        return [
          { icon: 'ri-dashboard-line', label: 'General Dashboard', path: '/' },
          { icon: 'ri-line-chart-line', label: 'Performance Overview', path: '/reports/finance' },
          { icon: 'ri-team-line', label: 'Team Management', path: '/admin/system' },
          { icon: 'ri-settings-line', label: 'Operations', path: '/orders/fulfillment' },
          { icon: 'ri-user-line', label: 'Customer Relations', path: '/customers' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/branch' },
        ];
      case 'sales_executive':
        return [
          { icon: 'ri-dashboard-line', label: 'Sales Dashboard', path: '/' },
          { icon: 'ri-shopping-cart-line', label: 'Sales Workflow', path: '/sales/workflow' },
          { icon: 'ri-product-hunt-line', label: 'Product Catalog', path: '/products' },
          { icon: 'ri-shopping-bag-line', label: 'Order Booking', path: '/sales/orders' },
          { icon: 'ri-money-rupee-circle-line', label: 'Payment Processing', path: '/sales/payment' },
          { icon: 'ri-user-line', label: 'Customer Management', path: '/customers' },
          { icon: 'ri-coins-line', label: 'Old Gold Purchase', path: '/inventory/old-gold' },
          { icon: 'ri-shield-check-line', label: 'Warranty Claims', path: '/warranty/claims' },
        ];
      case 'quality_control':
        return [
          { icon: 'ri-dashboard-line', label: 'QC Dashboard', path: '/qc' },
          { icon: 'ri-search-line', label: 'Order Inspections', path: '/qc/orders' },
          { icon: 'ri-file-list-line', label: 'QC Checklists', path: '/qc/checklists' },
          { icon: 'ri-tools-line', label: 'Repair Orders', path: '/warranty/repairs' },
        ];
      case 'finance':
        return [
          { icon: 'ri-dashboard-line', label: 'Finance Dashboard', path: '/' },
          { icon: 'ri-file-text-line', label: 'Invoice Management', path: '/billing/invoices' },
          { icon: 'ri-money-rupee-circle-line', label: 'Rate Fixation', path: '/billing/rates' },
          { icon: 'ri-credit-card-line', label: 'Payment Processing', path: '/billing/payment' },
          { icon: 'ri-file-chart-line', label: 'Financial Reports', path: '/reports/finance' },
          { icon: 'ri-calculator-line', label: 'GST Reports', path: '/reports/gst' },
        ];
      case 'system_admin':
        return [
          { icon: 'ri-dashboard-line', label: 'Admin Dashboard', path: '/' },
          { icon: 'ri-settings-line', label: 'System Management', path: '/admin/system' },
          { icon: 'ri-user-settings-line', label: 'User Management', path: '/admin/system' },
          { icon: 'ri-shield-check-line', label: 'Security Settings', path: '/admin/system' },
          { icon: 'ri-database-line', label: 'Data Management', path: '/admin/system' },
          { icon: 'ri-file-list-line', label: 'Audit Logs', path: '/admin/system' },
        ];
      case 'customer':
        return [
          { icon: 'ri-dashboard-line', label: 'My Dashboard', path: '/customer/portal' },
          { icon: 'ri-shopping-bag-line', label: 'My Orders', path: '/customer/portal' },
          { icon: 'ri-shield-check-line', label: 'Warranty', path: '/customer/portal' },
          { icon: 'ri-star-line', label: 'Loyalty Points', path: '/customer/portal' },
          { icon: 'ri-user-line', label: 'Profile', path: '/customer/portal' },
        ];
      case 'vendor':
        return [
          { icon: 'ri-dashboard-line', label: 'Vendor Dashboard', path: '/vendor/portal' },
          { icon: 'ri-shopping-bag-line', label: 'Order Management', path: '/vendor/portal' },
          { icon: 'ri-product-hunt-line', label: 'Product Catalog', path: '/vendor/portal' },
          { icon: 'ri-money-rupee-circle-line', label: 'Payments', path: '/vendor/portal' },
          { icon: 'ri-bar-chart-line', label: 'Performance', path: '/vendor/portal' },
        ];
      default:
        return [
          { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/' },
          { icon: 'ri-shopping-cart-line', label: 'Sales', path: '/sales/workflow' },
          { icon: 'ri-user-line', label: 'Customers', path: '/customers' },
          { icon: 'ri-box-line', label: 'Inventory', path: '/inventory' },
          { icon: 'ri-file-chart-line', label: 'Reports', path: '/reports/finance' },
        ];
    }
  };

  const getRoleDisplayName = (role: string) => {
    const roleNames: { [key: string]: string } = {
      'ceo': 'CEO',
      'director': 'Director',
      'operations_head': 'Operations Head',
      'ho_manager': 'HO Manager',
      'sales_head': 'Sales Head',
      'regional_manager': 'Regional Manager',
      'manager_pobs': 'Manager POBS',
      'branch_manager': 'Branch Manager',
      'store_manager': 'Store Manager',
      'general_manager': 'General Manager',
      'sales_executive': 'Sales Executive',
      'quality_control': 'Quality Control',
      'finance': 'Finance',
      'system_admin': 'System Admin',
      'customer': 'Customer',
      'vendor': 'Vendor'
    };
    return roleNames[role] || role;
  };

  const userMenus = getMenuItems();

  return (
    <div className="w-64 bg-white shadow-lg h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-[#800020] rounded-lg flex items-center justify-center">
            <i className="ri-gem-line text-white text-xl"></i>
          </div>
          <div>
            <h1 className="text-xl font-bold text-[#800020]" style={{ fontFamily: 'Pacifico, serif' }}>
              Prince
            </h1>
            <p className="text-xs text-gray-500">Jewelry Management</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
        {userMenus.map((item) => {
          const isActive = location.pathname === item.path || 
                          (item.path !== '/' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'bg-[#800020] text-white'
                  : 'text-gray-700 hover:bg-[#f4e1c1]/30'
              }`}
            >
              <i className={`${item.icon} text-lg`}></i>
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* User Info */}
      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <span className="text-white text-sm font-medium">
              {user?.name?.charAt(0) || 'U'}
            </span>
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-900">{user?.name || 'User'}</p>
            <p className="text-xs text-gray-500">{getRoleDisplayName(user?.role || '')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
